import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useApp } from '../context/AppContext';
import { getDemoUser, getFacilities, getFacility, getUserProfile } from '../services';
import { firebaseEnabled } from '../lib/firebase';

export function useCurrentFacility() {
  const { facilityId } = useApp();
  return useQuery({ queryKey: ['facility', facilityId], queryFn: () => getFacility(facilityId) });
}

export function useFacilities() {
  return useQuery({ queryKey: ['facilities'], queryFn: getFacilities });
}

export function useCurrentUser() {
  const { role, facilityId, uid } = useApp();
  return useQuery({
    queryKey: ['user', firebaseEnabled ? uid : role, facilityId],
    queryFn: () => (firebaseEnabled && uid ? getUserProfile(uid) : getDemoUser(role, facilityId)),
    enabled: !firebaseEnabled || !!uid,
  });
}

const DEFAULT_ACCENT = '#D97706';

export function useBrandColor(color?: string) {
  useEffect(() => {
    document.documentElement.style.setProperty('--brand', color ?? DEFAULT_ACCENT);
  }, [color]);
}
